import tutorProfile from './tutor.json';
import chaoticProfile from './chaotic.json';

export const profiles = {
  tutor: {
    id: 'tutor',
    name: 'Tutor',
    data: tutorProfile
  },
  chaotic: {
    id: 'chaotic',
    name: 'Chaotic',
    data: chaoticProfile
  }
};

export const defaultProfile = profiles.tutor; 